import type { StatusChipVariant } from '@/components/ui/status-chip';
import type { NotificationMessageAction, NotificationMessageStatus } from '@/services/api/notifications';

export const STATUS_LABELS: Record<NotificationMessageStatus, string> = {
  DRAFT: 'Draft',
  IN_REVIEW: 'In review',
  SENT: 'Sent',
  CANCELLED: 'Cancelled',
};

export const STATUS_CHIP_VARIANTS: Record<NotificationMessageStatus, StatusChipVariant> = {
  DRAFT: 'muted',
  IN_REVIEW: 'info',
  SENT: 'success',
  CANCELLED: 'muted',
};

// The two send variants share a label on purpose: whether Legal have approved changes the
// confirmation dialog, not the button
export const ACTION_LABELS: Record<NotificationMessageAction, string> = {
  AMEND: 'Amend',
  SUBMIT: 'Send for approval',
  LEGAL_APPROVE: 'Legal approve',
  LEGAL_WITHDRAW: 'Withdraw legal approval',
  RETURN: 'Return',
  CANCEL: 'Cancel',
  SEND: 'Approve & send',
  SEND_REQUIRES_ACKNOWLEDGEMENT: 'Approve & send',
};

const ACTION_ORDER: NotificationMessageAction[] = ['SUBMIT', 'LEGAL_APPROVE', 'LEGAL_WITHDRAW', 'RETURN', 'SEND', 'SEND_REQUIRES_ACKNOWLEDGEMENT', 'AMEND', 'CANCEL'];

// Server-driven: allowed_actions arrives in server order, buttons render in the fixed display order
export const orderMessageActions = (allowed: readonly NotificationMessageAction[]): NotificationMessageAction[] => ACTION_ORDER.filter((action) => allowed.includes(action));
